/* global window */
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// components
import OverlayLoader from '../../../parts/OverlayLoader';
import SuccessConfirmationOverlay from '../../../parts/SuccessConfirmationOverlay';
import FailureOverlay from '../../../parts/FailureOverlay';

// actions
import { updatePermissions } from '../../../actions/user';

function ActiveCircleIcon({ active = false }) {
  return active ?
    <i className="sa sa-tick-circle u-text-positive toggle__circle" /> :
    <i className="sa sa-times-circle u-text-negative toggle__circle" />;
}

function Mail({ active = false, toggle }) {
  return (
    <button
      className="c-btn c-btn--text toggle"
      onClick={toggle}
    >
      <div className="sa sa-mail" />
      <ActiveCircleIcon active={active} />
    </button>
  );
}

function Phone({ active = false, toggle }) {
  return (
    <button
      className="c-btn c-btn--text toggle"
      onClick={toggle}
    >
      <div className="sa sa-contact" />
      <ActiveCircleIcon active={active} />
    </button>
  );
}

class _Settings extends Component {

  constructor(props) {
    super(props);
    const { canEmail, canText } = props;
    this.state = {
      canEmail,
      canText,
      loadState: 'none'
    };
    this.savePermissions = this.savePermissions.bind(this);
  }

  componentWillReceiveProps(newProps) {
    const { oldCanEmail, oldCanText } = this.state;
    const { canEmail, canText } = newProps;
    if(oldCanEmail === canEmail && oldCanText === canText) return;
    this.setState({ canEmail, canText });
  }


  savePermissions() {
    const { canEmail, canText } = this.state;
    this.setState({ loadState: 'loading' });
    this.props.updatePermissions({ canEmail, canText })
    .then(() => {
      this.setState({ loadState: 'success' });
      window.setTimeout(() => this.setState({ loadState: 'none' }), 5000);
    })
    .catch(() => {
      this.setState({ loadState: 'failure' });
      window.setTimeout(() => this.setState({ loadState: 'none' }), 5000);
    });
  }

  render() {
    const { canText, canEmail } = this.state;
    return (
      <div className="c-user-details-card__settings">
        <strong>Contact preferences:</strong>
        <div className="u-flex u-flex-align-items-center u-flex-justify-start u-padding-top-small">
          <Mail
            active={canEmail}
            toggle={() => this.setState({ canEmail: !canEmail })}
          />
          <div className="toggle__blurb u-padding-x-tiny">I am happy to receive information about sofology products and special offers by email.</div>

        </div>

        <div className="u-flex u-flex-align-items-center u-flex-justify-start u-padding-top-small">
          <Phone
            active={canText}
            toggle={() => this.setState({ canText: !canText })}
          />
          <div className="toggle__blurb u-padding-x-tiny">I am happy to receive information about sofology products and special offers by telephone, text message, and or by recorded call.</div>
        </div>

        <div className="controls">

          <OverlayLoader active={this.state.loadState === 'loading'} background="rgba(247, 247, 247, 0.8)" scale={0.5} />

          {this.state.loadState === 'success' ? <SuccessConfirmationOverlay background="rgba(247, 247, 247, 0.8)" /> : null}
          {this.state.loadState === 'failure' ? <FailureOverlay background="rgba(247, 247, 247, 0.8)" /> : null}
          <button
            className="c-btn c-btn--link"
            onClick={this.savePermissions}
            disabled={(this.props.canEmail === canEmail && this.props.canText === canText) || this.state.loadState !== 'none'}
          >
            save changes
          </button>
        </div>

      </div>
    );
  }
}

const mapStateToProps = state => ({
  canEmail: state.user.permissions.canEmail,
  canText: state.user.permissions.canText,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  updatePermissions
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(_Settings);



// WEBPACK FOOTER //
// ./src/cards/templates/UserDetailsCard/Settings.js